export default "__VITE_ASSET__BLZ7oxqp__"